module.exports = __webpack_public_path__ + "static/media/my-offer.6089945c.svg";